import { mapActions } from 'vuex'
import Modal from '@/components/modals/modal/modal.vue'
import emitHideMixin from '@/components/modals/mixins/emit-hide'

export default {
  name: 'TakeawayModal',
  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [ emitHideMixin ],
  props: {
    orderId: String,
    orderStatus: String
  },
  components: {
    Modal
  },
  computed: {
    isDisabled() {
      return this.orderStatus !== 'cooked'
    },
    statusText() {
      switch(this.orderStatus) {
        case 'payed':
          return 'оплачен'
        case 'cooked':
          return 'готов к выдаче'
        default: 
          return 'не готов'
      }
    }
  },
  methods: {
    ...mapActions({
      updateOrder: 'orders/updateOrder'
    }),
    async pay() {
      await this.updateOrder({
        orderId: this.orderId,
        data: {
          action: 'set_paid'
        }
      })
      this.hide()
    },
    show () {
      this.$refs.modal.show()
    }
  }
}